<div  class="text-center login_center">
  <div class="form-signin">
    <div class="radius_border text-left">
        <img alt="" class="mb-4 logo" style="height:3rem;" src="../../../assets/img/new-logo.png">
        <div class="container">
        <div class="row">
            <span style="font-size: medium;"><b>Reset your password?</b></span>
            <p class="mt-4">Enter the email address associated with your account and we’ll send the link to reset the password.</p>
        </div>
       
  
        <div class="tab-content mt-4 reset-container">
          <div>
            <form [formGroup]="emailForm" (keydown.enter)="submitMail();">
  
              <div class="mb-4">
                <input [ngClass]="{ 'is-invalid': submitted && emailForm.controls['email'].errors }"
                       class="form-control" formControlName="email"
                       id="email" placeholder="Email"
                       type="email">
                <div class="invalid-feedback">
                  Please enter a email
                </div>
                
              </div>
  
              <div class="row">
                <div class="col-6">
                    <button  class="btn btn-primary" (click)="submitMail()" style="background-color: rgb(74, 11, 119);">  
                        CONTINUE
                    </button>
                </div>
                <div class="col-6 text-right mt-2">
                   
                        <a href=" ">Back to Login</a>
                      
                </div>
                
              </div>
             
            </form>
  
          </div>
  
        </div>
      </div>
      </div>
    </div>
  </div>
  <p-toast></p-toast>